import React from 'react';
import Modal from 'react-responsive-modal';
import { ppeComponentModalStyles } from '../Modal/styles';

const GeneralVesselListModal = ({ vesselListModal, setVesselListModal, generalVesselList }) => {
    return (
    <div className="modal-content add-vesse-group-root">
    <Modal
    open={vesselListModal}
    onClose={() => {
    setVesselListModal(false);
    }}
    closeOnOverlayClick
    showCloseIcon={false}
    blockScroll={false}
    focusTrapped={false}
    modal={
        { ...ppeComponentModalStyles.modal,
        overflow: 'visible',
        maxHeight: '90vh'
        }
      }
    styles={ppeComponentModalStyles}
    center
    >
      <div className="uppercase text-center font-bold text-xl pb-5 font-montserrat">
        Mapped Vessel List
      </div>
    <div className="add-vessel-group-text-box">
               {generalVesselList?.mappedVessels?.length > 0 && generalVesselList
               ?.mappedVessels.map((item) => {
                 return (
                   <span
                     className=" text-gray-100 p-1 block font-muli text-left input-label add-vessel-group-text-box-chip"
                     key={item?.vesselCode}
                   >
                     <p className="text-gray-100 opacity-60">
                     {item?.vesselName}
                     <span>  [</span>
                     {item?.imoNumber}
                     <span>, VC</span>
                     <span>
                     {item?.vesselCode}
                     </span>
                      <span>] </span>
                     </p>
                   </span>
                 );
               })}
    </div>
    </Modal>
    </div>
  );
};

export default GeneralVesselListModal;
